import React from 'react';
import { ITableDataSource } from 'models/table';
import { Grid, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import Button from 'components/atoms/Button';
import { Chips } from 'components/atoms/Chips';
import {
  StyledTableCard,
  StyledTableCardItem,
} from 'pages/CaseManagementPage/CasesPage/styles';
import { ETaskStatus } from 'constants/Case';

interface ITasksTableCard {
  data: ITableDataSource;
  viewAction: (id: string) => void;
  editAction: (id: string) => void;
  deleteAction: (id: string) => void;
  renderStatusFieldColor: (arg: ITableDataSource) => any;
  isReadOnly?: boolean;
}

export const TasksTableCard = ({
  data,
  viewAction,
  editAction,
  deleteAction,
  renderStatusFieldColor,
  isReadOnly,
}: ITasksTableCard) => {
  const { t } = useTranslations();

  return (
    <StyledTableCard container>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.task)}</Typography>
        <Typography variant="body2">{data.task}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastUpdate)}</Typography>
        <Typography variant="body2">{data.lastUpdate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.lastAuthor)}</Typography>
        <Typography variant="body2">{data.lastAuthor}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.status)}</Typography>
        <Typography variant="body2">
          <Chips text={data.status} variant={renderStatusFieldColor(data)} />
        </Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.actions)}</Typography>
        <Grid container size={{ xs: 12 }} columnSpacing={1}>
          <Grid size={{ xs: 6 }}>
            {!isReadOnly && data.statusUniqueId !== ETaskStatus.DONE ? (
              <Button
                variant={EButtonVariants.contained}
                tableButton
                label={t('general.view.label')}
                onClick={() => editAction(data.id as string)}
                id="tasks_table_card_edit-button"
                fullWidth
              />
            ) : (
              <Button
                variant={EButtonVariants.outlined}
                tableButton
                label={t('general.view.label')}
                onClick={() => viewAction(data.id as string)}
                id="tasks_table_card_view-button"
                fullWidth
              />
            )}
          </Grid>
          <Grid size={{ xs: 6 }}>
            {!isReadOnly && !data.fromTemplate && (
              <Button
                variant={EButtonVariants.contained}
                tableButton
                label={t('general.delete.label')}
                onClick={() => deleteAction(data.id as string)}
                id="tasks_table_card_delete-button"
                fullWidth
              />
            )}
          </Grid>
        </Grid>
      </StyledTableCardItem>
    </StyledTableCard>
  );
};
